// Generated by purs version 0.15.16
var lift = function (dict) {
    return dict.lift;
};
export {
    lift
};
//# sourceMappingURL=index.js.map
